module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_iter-step.js
// module id = 836
// module chunks = 0